/**
 * Persist the fSelect search box across a FacetWP refresh.
 *
 * When a checkbox is ticked inside an fSelect facet, FacetWP autoloads and
 * replaces the facet's entire markup ( see front.js render(): it does
 * $( '.facetwp-facet-<name>' ).html( val ) ), which destroys the search input
 * and the text in it. front-facets.js then re-inits fSelect and re-opens the
 * active multi-select facet — but the search field comes back empty, so the
 * option list snaps back to the full, unfiltered set.
 *
 * This module captures the typed search text just before the refresh ( on
 * fSelect's `fs:changed` event, while the old DOM still exists ), keyed by the
 * facet name, then writes it back into the re-rendered facet on `facetwp-loaded`
 * and dispatches a `keyup` so fSelect re-applies its filter. Both events are
 * bubbling CustomEvents dispatched on document by FacetWP/fSelect, so plain
 * document listeners catch them. This file is imported in main.js.
 */

document.addEventListener( 'DOMContentLoaded', () => {

	// Pending search text to restore, keyed by facet name. Map<string, string>.
	const pending = new Map();

	// Read the facet name for a given .fs-wrap ( its <select> lives in a
	// .facetwp-facet[data-name] container ).
	const facetNameFor = ( wrap ) => {
		const facet = wrap ? wrap.closest( '.facetwp-facet' ) : null;
		return facet ? facet.getAttribute( 'data-name' ) : null;
	};

	// Just before FacetWP refreshes, stash the current search text. fSelect
	// fires `fs:changed` with detail = [ wrap ]; the old DOM is still in place.
	document.addEventListener( 'fs:changed', ( event ) => {
		const wrap = event.detail && event.detail[0];

		if ( ! wrap ) {
			return;
		}

		const name = facetNameFor( wrap );
		const input = wrap.querySelector( '.fs-search input' );

		if ( name && input && '' !== input.value ) {
			pending.set( name, input.value );
		}
	});

	// After the refresh, FacetWP has re-inited fSelect and re-opened the active
	// facet. Write the stashed text back and re-run the filter.
	document.addEventListener( 'facetwp-loaded', () => {

		if ( 0 === pending.size ) {
			return;
		}

		pending.forEach( ( value, name ) => {
			const facet = document.querySelector( '.facetwp-facet[data-name="' + name + '"]' );
			const input = facet ? facet.querySelector( '.fs-search input' ) : null;

			if ( input ) {
				input.value = value;
				input.dispatchEvent( new Event( 'keyup', { bubbles: true }) );
			}
		});

		pending.clear();
	});
});
